import dataProvider from 'shared/rest';
import axios from 'axios';
/**
 * The rule for file storage location:
 * Root-> /groups
 * banner -> /groups/banner
 * cover -> /groups/covers
 * posts -> /groups/:groupId/posts/
 * events -> /groups/:groupId/events/
 *
 */
function NewGuid() {
  var sGuid = '';
  for (var i = 0; i < 32; i++) {
    sGuid += Math.floor(Math.random() * 0xf).toString(0xf);
  }
  return sGuid;
}
const root = '/groups';
/**
 *
 * @param {*} param0
 */
const getPresignedPutUrl = async ({ location, groupId, file }) => {
  const uuid = NewGuid();
  const contentType = file.type;
  let key = '';
  if (groupId) {
    key = `${root}/${groupId}/${location}/${uuid}`;
  } else {
    key = `${root}/${location}/${uuid}`;
  }
  const params = {
    key,
    contentType,
  };
  const { code, data } = await dataProvider.invoke(
    'oss',
    'getPresignedPutUrl',
    params
  );
  console.log(`code:${code} data: ${JSON.stringify(data)}`);
  if (code !== 0) return null;
  const res = await uploadFileByUrl(data, file);
  console.log(`res ${res}`);
  const uploadedFileUrl = data.split('?')[0];
  return uploadedFileUrl;
};

const uploadFileByUrl = async (url, file) => {
  const contentType = file.type;

  var config = {
    method: 'put',
    url,
    headers: {
      'Content-Type': contentType,
    },
    data: file,
    withCredentials: false,
  };

  const res = await axios(config);
  return res;
};

export default getPresignedPutUrl;
